<template>
  <div class="dashboard-card">
    <!-- HEADER -->
    <div
      v-if="hasSlot('header')"
      class="dashboard-card__header"
    >
      <!-- HEADER CONTENT -->
      <div class="dashboard-card__header-content">
        <slot name="header" />
      </div>

      <!-- HEADER EXTRA CONTENT -->
      <div
        v-if="hasSlot('headerExtraContent')"
        class="dashboard-card__header-content-extra"
      >
        <slot name="headerExtraContent" />
      </div>
    </div>

    <!-- SPINNER -->
    <template v-if="loading">
      <div
        class="dashboard-card__skeleton"
        :style="{ minHeight: minSkeletonHeight }"
      >
        <a-spin>
          <a-icon
            type="loading"
            slot="indicator"
            style="color: rgba(0, 0, 0, 0.45)"
          />
        </a-spin>
      </div>
    </template>

    <!-- EMPTY CONTENT -->
    <template v-else-if="isEmpty && hasSlot('empty')">
      <div class="dashboard-card__empty">
        <slot name="empty" />
      </div>
    </template>

    <!-- MAIN CONTENT -->
    <template v-else>
      <!-- BODY -->
      <div
        v-if="hasSlot('body')"
        class="dashboard-card__body"
      >
        <slot name="body" />
      </div>

      <!-- FOOTER -->
      <div
        v-if="hasSlot('footer')"
        class="dashboard-card__footer"
      >
        <slot name="footer" />
      </div>
    </template>
  </div>
</template>

<script lang="ts">
export default {
  name: "DashboardCard",

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    isEmpty: {
      type: Boolean,
      default: false
    },

    minSkeletonHeight: {
      type: String,
      default: "0px"
    }
  },

  methods: {
    hasSlot(slotName): boolean {
      return slotName in this.$slots
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-card {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 12px;
  font-size: 14px;
  line-height: 21px;

  &__header {
    border-bottom: 1px solid #e8e8e8;
    padding: 0 0 8px 0;
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__header-content {
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: rgba(0, 0, 0, 0.85);
  }

  &__header-content-extra {
  }

  &__body {
    padding: 8px 0;

    &:last-child {
      padding-bottom: 0;
    }

    &:first-child {
      padding-top: 0;
    }
  }

  &__footer {
    border-top: 1px solid #e8e8e8;
    padding: 8px 0 0 0;
    font-size: 13px;
  }

  &__skeleton {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 12px);
  }
}
</style>
